import { useState } from "react";
import { Button } from "../ui/Button";
import { CorrectionModal } from "./CorrectionModal";
import type { BrandEditSourceType } from "../../../../shared/types";

interface CorrectionButtonProps {
  sourceType: BrandEditSourceType;
  sourceId: string | null;
  brandId: string;
  contextHint?: string;
}

export function CorrectionButton({ sourceType, sourceId, brandId, contextHint }: CorrectionButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => setOpen(true)}>
        Correct
      </Button>
      <CorrectionModal
        open={open}
        onClose={() => setOpen(false)}
        brandId={brandId}
        sourceType={sourceType}
        sourceId={sourceId}
        contextHint={contextHint}
      />
    </>
  );
}
